/**
 * Product tabs - switches visible panel when a tab is clicked
 * @param {HTMLElement} container - Section element containing .product-tabs__tab and .product-tabs__panel
 */
function initProductTabs(container) {
  const tabs = container.querySelectorAll('.product-tabs__tab');
  const panels = container.querySelectorAll('.product-tabs__panel');

  if (!tabs.length || !panels.length) return;

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      const index = tab.getAttribute('data-index');
      if (index == null) return;

      tabs.forEach((t) => {
        t.classList.remove('is-active');
        t.setAttribute('aria-selected', 'false');
      });
      tab.classList.add('is-active');
      tab.setAttribute('aria-selected', 'true');

      panels.forEach((panel, i) => {
        if (String(i) === index) {
          panel.classList.add('is-active');
          panel.removeAttribute('hidden');
          panel.setAttribute('aria-hidden', 'false');
        } else {
          panel.classList.remove('is-active');
          panel.setAttribute('hidden', '');
          panel.setAttribute('aria-hidden', 'true');
        }
      });
    });
  });
}

document.querySelectorAll('.product-tabs').forEach((el) => initProductTabs(/** @type {HTMLElement} */ (el)));

// Re-init when Shopify theme editor re-renders sections
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const target = /** @type {HTMLElement} */ (event.target);
    const section = target?.querySelector?.('.product-tabs');
    if (section && section.parentElement) {
      initProductTabs(section.closest('[id^="ProductTabs-"]') || section.parentElement);
    }
  });
}
